/*
    Class encapsulate a pagable response that a service receives from remote api calls.
    Except for base service we should not throw any other exception, the caller only expects
    an instance of this class with proper messages in the error
*/
export class ApiPagedResponse<T> {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: Array<T>;

    constructor() {
        this.items = new Array<T>();
    }

    public prepareForNonStandard(): void {
        this.pageIndex = 0;
        this.pageSize = 50;
        this.totalCount = 0;
        this.totalPages = 1;
        this.hasPreviousPage = false;
        this.hasNextPage = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/api-response-models/api-paged-response.model.ts